export const sfNotLinked = "sfNotLinked";
export const sfFieldMatchError = "sfFieldMatchError";
export const teamOnlyAllowed = "teamOnlyAllowed";
export const slackOnlyAllowed = "slackOnlyAllowed";
export const isEnterpriseEmailCustomizations = "isEnterpriseEmailCustomizations";
export const chatToolsNotLinked = "chatToolsNotLinked";
export const customAttendanceRuleBlocked = "customAttendanceRuleBlocked";
